import { render, staticRenderFns } from "./GrantFarmAccess.vue?vue&type=template&id=b925eb62&scoped=true"
import script from "./GrantFarmAccess.vue?vue&type=script&lang=js"
export * from "./GrantFarmAccess.vue?vue&type=script&lang=js"
import style0 from "./GrantFarmAccess.vue?vue&type=style&index=0&id=b925eb62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b925eb62",
  null
  
)

export default component.exports